var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, computed, observable } from "mobx";
import { BlockchainTransactionState } from "../Logic/BlockchainTransactionManager";
import { formatDistance } from "date-fns";
export class BlockchainTransactionDialogModel {
    constructor(container) {
        this.now = new Date();
        this.blockchainTransactionStatusManager = container.blockchainTransactionManager;
        this.updateTime();
        this.interval = setInterval(() => {
            this.updateTime();
        }, 1000);
    }
    get open() {
        return this.blockchainTransactionStatusManager.transaction !== undefined;
    }
    get state() {
        var _a;
        if (this.isExpired) {
            return BlockchainTransactionState.EXPIRED;
        }
        return (_a = this.blockchainTransactionStatusManager.transaction) === null || _a === void 0 ? void 0 : _a.state;
    }
    get requestType() {
        var _a, _b;
        return (_b = (_a = this.blockchainTransactionStatusManager.transaction) === null || _a === void 0 ? void 0 : _a.requestType) !== null && _b !== void 0 ? _b : "";
    }
    get isExpired() {
        if (!this.blockchainTransactionStatusManager.transaction) {
            return false;
        }
        if (this.blockchainTransactionStatusManager.transaction.state !== BlockchainTransactionState.WAITING_TO_CONFIRM) {
            return false;
        }
        return this.now > this.blockchainTransactionStatusManager.transaction.expiry;
    }
    get expiry() {
        if (!this.blockchainTransactionStatusManager.transaction) {
            return "-";
        }
        return formatDistance(this.blockchainTransactionStatusManager.transaction.expiry, this.now, {
            addSuffix: false,
            includeSeconds: true,
        });
    }
    get isSpinnerVisible() {
        switch (this.state) {
            case BlockchainTransactionState.WAITING_TO_CONFIRM:
                return true;
            case BlockchainTransactionState.CONFIRMING:
                return true;
            default:
                return false;
        }
    }
    get title() {
        switch (this.state) {
            case BlockchainTransactionState.WAITING_TO_CONFIRM:
                return "Waiting for you to confirm your request";
            case BlockchainTransactionState.CONFIRMING:
                return "Confirming your response...";
            case BlockchainTransactionState.CONFIRMED:
                return "Request confirmed";
            case BlockchainTransactionState.DENIED:
                return "Request denied";
            case BlockchainTransactionState.EXPIRED:
                return "Request timed out";
            default:
                return undefined;
        }
    }
    get messages() {
        switch (this.state) {
            case BlockchainTransactionState.WAITING_TO_CONFIRM:
                return [
                    `To confirm it’s you making this request, please open your HealthEx Authenticator App.`,
                    `You have ${this.expiry} to confirm this request.`,
                ];
            case BlockchainTransactionState.CONFIRMING:
                return [
                    `We’re just connecting to the HealthEx Authenticator App to confirm your response.`,
                    `This should only take a few seconds.`,
                ];
            case BlockchainTransactionState.CONFIRMED:
                return [`You have confirmed your ${this.requestType}.`, `Close this pop-up to continue.`];
            case BlockchainTransactionState.DENIED:
                return [
                    `You have denied your ${this.requestType}. This request will not be processed.`,
                    `This request will not be processed. You can send the request again, or close this pop-up to continue.`,
                ];
            case BlockchainTransactionState.EXPIRED:
                return [`Your ${this.requestType} has timed out.`, `You can send the request again, or close this pop-up to continue.`];
            default:
                return [];
        }
    }
    get message2() {
        switch (this.state) {
            case BlockchainTransactionState.WAITING_TO_CONFIRM:
                return `You have ${this.expiry} to confirm this request.`;
            case BlockchainTransactionState.CONFIRMING:
                return `This should only take a few seconds.`;
            case BlockchainTransactionState.CONFIRMED:
                return `Close this pop-up to continue.`;
            case BlockchainTransactionState.DENIED:
                return `This request will not be processed. You can send the request again, or close this pop-up to continue.`;
            case BlockchainTransactionState.EXPIRED:
                return `You can send the request again, or close this pop-up to continue.`;
            default:
                return undefined;
        }
    }
    get buttons() {
        switch (this.state) {
            case BlockchainTransactionState.CONFIRMED:
                return [{ label: "Close" }];
            case BlockchainTransactionState.DENIED:
                return [{ label: "Close" }, { label: "Send request again", resend: true }];
            case BlockchainTransactionState.EXPIRED:
                return [{ label: "Cancel" }, { label: "Send request again", resend: true }];
            default:
                return [];
        }
    }
    onClose() {
        this.blockchainTransactionStatusManager.clearTransaction();
    }
    async onChoice(resend) {
        if (resend) {
            console.log(`Resending transaction`);
            await this.blockchainTransactionStatusManager.resendTransaction();
        }
        else {
            this.blockchainTransactionStatusManager.clearTransaction();
        }
    }
    updateTime() {
        this.now = new Date();
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], BlockchainTransactionDialogModel.prototype, "now", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "open", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "state", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "requestType", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "isExpired", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "expiry", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "isSpinnerVisible", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "title", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "messages", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "message2", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], BlockchainTransactionDialogModel.prototype, "buttons", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BlockchainTransactionDialogModel.prototype, "updateTime", null);
